import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, unref as _unref, isRef as _isRef, vModelDynamic as _vModelDynamic, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["placeholder", "type", "autofocus"]
const _hoisted_2 = { class: "v-input-outlined__error" }

import { useVModel } from '@vueuse/core'
import { DefineComponent, onMounted, ref, VueElement } from 'vue';
import CloseIcon from './icons/navigation/CloseIcon.vue';
import VIconButton from './VIconButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'VAuthInput',
  props: {
    modelValue: null,
    placeholder: null,
    type: null,
    icon: null,
    error: null,
    light: { type: Boolean },
    autofocus: { type: Boolean },
    clearable: { type: Boolean }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as {
  modelValue?: string,
  placeholder?: string,
  type?: string,
  icon?: VueElement | DefineComponent<any, any, any>,
  error?: string,
  light?: boolean,
  autofocus?: boolean,
  clearable?: boolean
}

const inputRef = ref<HTMLInputElement>()



const model = useVModel(props, 'modelValue', emit)

onMounted(() => {
  if (props.autofocus && window.innerWidth > 600) {
    inputRef.value?.focus()
  }
})

const reset = (e: MouseEvent) => {
  e.stopPropagation()
  emit("update:modelValue", "")
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["v-input-outlined", { error: !!props.error, 'no-icon': !props.icon }])
  }, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(props.icon), { class: "v-input-outlined__icon" })),
    _withDirectives(_createElementVNode("input", {
      ref_key: "inputRef",
      ref: inputRef,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(model) ? (model).value = $event : null)),
      placeholder: props.placeholder,
      type: props.type,
      autofocus: __props.autofocus
    }, null, 8, _hoisted_1), [
      [_vModelDynamic, _unref(model)]
    ]),
    _createElementVNode("div", _hoisted_2, _toDisplayString(props.error), 1),
    _renderSlot(_ctx.$slots, "append"),
    (props.clearable && !!_unref(model))
      ? (_openBlock(), _createBlock(VIconButton, {
          key: 0,
          class: "v-input-outlined__close-button",
          onClick: reset
        }, {
          default: _withCtx(() => [
            _createVNode(CloseIcon)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 2))
}
}

})